import React, { useState, useEffect, useRef } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Imgcross from '../../assets/img/cross.png';

import toast, { Toaster } from 'react-hot-toast';

import apiPath from "../../constants/apiPath";
import Http from "../../services/Http";
import { internalIpV4 } from '../../services/getIp';

import { ValidationForm, TextInput, TextInputGroup, FileInput, SelectGroup, Checkbox } from "react-bootstrap4-form-validation";
import validator from 'validator'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import Login from '../Modal/Login';
import OtpVerify from '../Modal/OtpVerify';

import { userLogin } from "../../actions/index";
import { connect } from "react-redux";

import LocalizedStrings from 'react-localization';
import localization from '../../localization';
import eyeSvgrepoCom from "../../assets/img/eye-svgrepo-com.svg";
import eyeOffSvgrepoCom from "../../assets/img/eye-off-svgrepo-com.svg";
let strings = new LocalizedStrings(localization);

const mapStateToProps = state => {
    return { user: state.user };

};

const mapDispatchToProps = dispatch => {
    return {
        userLogin: user => dispatch(userLogin(user))
    };
};

const Register = (Props) => {
    const [showRegister, setShowRegister] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [showOtp, setShowOtp] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submitLock = useRef(false);
    const [getRegister, setRegister] = useState({
        mobile: '',
        country_code: '',
        name: '',
    });


    const [currentLang, setCurrentLang] = useState(
        localStorage.getItem("current_lang")
            ? localStorage.getItem("current_lang")
            : "en"
    );
    strings.setLanguage(currentLang);

    const formRef = React.createRef();
    const registerClose = () => setShowRegister(false);

    const openLogin = () => {
        setShowRegister(false);
        setShowLogin(true);
    }

    const registerSubmit = async (e, formData, inputs) => {
        e.preventDefault();
        if (submitLock.current || !validate()) {
            return;
        }

        submitLock.current = true;
        setIsSubmitting(true);
        try {
            let path = apiPath.register;
            var data = new FormData();

            console.log(formData)
            data.append('email', formData.email);
            data.append('password', formData.password);
            data.append('confirm_password', formData.confirm_password);
            data.append('country_code', getRegister.country_code);
            data.append('mobile', getRegister.mobile);
            data.append('device_type', 'Website');
            data.append('device_token', await internalIpV4());
            data.append('preferred_country', Props.user.details ? Props.user.details.preferred_country : '');
            data.append('preferred_language', Props.user.details ? Props.user.details.preferred_language : '');
            let options = {
                method: 'POST',
                data: data
            }
            let result = await Http(path, options);
            if (result.status === 200) {
                if (result.data.status) {
                    setShowRegister(false);
                    Props.userLogin(result.data.data);
                    toast.success(result.data.message);
                    window.location.reload();

                    // setShowOtp(true);

                } else {
                    toast.error(result.data.message);
                }
            } else {
                if(result.statusText != null) {
                    toast.error(result?.data?.message || result.statusText);
                }
            }
        } finally {
            submitLock.current = false;
            setIsSubmitting(false);
        }
    }
    const [passwordType, setPasswordType] = useState("password");
    const [passwordInput, setPasswordInput] = useState("");
    const [passwordInput1, setPasswordInput1] = useState("");
    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    }
    const handlePasswordChange1 = (evnt) => {
        setPasswordInput1(evnt.target.value);
    }
    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const validate = () => {
        let isValid = true;
        if (!getRegister.mobile) {
            toast.error(strings.plz_enter_phone || 'Mobile is required');
            isValid = false;
        } else if (getRegister.mobile.length < 8 || getRegister.mobile.length > 12) {
            toast.error('Required 8 To 12 Digit');
            isValid = false;
        }
        return isValid;
    }
    const registerErrorSubmit = (e, formData, inputs) => {
        e.preventDefault();
    }
    const handleChange = (e) => {
        console.log(e.target.value)
        // var country_code = data.dialCode;
        //  setRegister({ country_code: country_code, mobile: value.slice(data.dialCode.length) });
        setRegister({ ...getRegister, email: e.target.value });
    }
    useEffect(() => {
        setShowRegister(Props.data);
    }, [Props]);
    return (
        <>
            {showLogin ? <Login data={showLogin} /> : ''}
            {showOtp ? <OtpVerify data={showOtp} userData={getRegister} /> : ''}

            <Modal show={showRegister} onHide={registerClose} animation={true} size="lg" backdrop="static" keyboard={false} centered >
                <Modal.Header >
                    <h5 className="modal-title" id="exampleModalLabel">{strings.sign_up}</h5>
                    <button type="button" className="btn-close" onClick={registerClose}>
                        <img alt='Close' src={Imgcross} onClick={registerClose} />
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-body'>
                    <ValidationForm onSubmit={registerSubmit} onErrorSubmit={registerErrorSubmit} ref={formRef} >

                        <div className="popup-cont">
                            <Form.Group className="form-group" controlId="form-group">
                                <Form.Label>{strings.enter_email}</Form.Label>
                                <TextInputGroup name="email" id="email" type="email"
                                    placeholder={strings.plz_enter_email}
                                    validator={validator.isEmail}
                                    errorMessage={{ validator: strings.plz_enter_valid_email }}
                                    // value={user.email}
                                    onChange={handleChange}
                                    required
                                />

                                {/* <Form.Control type="email" placeholder={strings.enter_email} name="email" onChange={handleChange} required /> */}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="form-group-mobile">
                                <Form.Label>{strings.mobile_number || 'Mobile Number'}</Form.Label>
                                <PhoneInput inputProps={{
                                    name: "mobile",
                                    required: true,
                                    autoFocus: false,
                                }}
                                    isValid={(value, country) => {
                                        const dialCode = country?.dialCode || '';
                                        const mobile = value.replace(dialCode, '');

                                        if (!mobile) {
                                            return strings.plz_enter_phone || 'Please enter mobile phone';
                                        }

                                        if (mobile.length < 8 || mobile.length > 12) {
                                            return 'Required 8 To 12 Digit';
                                        }

                                        return true;
                                    }}
                                    country={"kw"}
                                    value={`${getRegister.country_code}${getRegister.mobile}`}
                                    onChange={(value, data) => {
                                        const country_code = data.dialCode;
                                        setRegister({
                                            ...getRegister,
                                            country_code: country_code,
                                            mobile: value.slice(country_code.length)
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group className="form-group position-relative">
                                <Form.Label>Enter Password</Form.Label>
                                <TextInputGroup type={passwordType} name="password" onChange={handlePasswordChange} value={passwordInput} placeholder="Password" required />
                                <div className="input-group-btn passShowHideBtn position-absolute">
                                    {/* <button className="btn btn-outline-primary"> */}
                                    {passwordType === "password" ? <img alt='On' className='w-100' src={eyeSvgrepoCom} onClick={togglePassword} /> : <img className='w-100' src={eyeOffSvgrepoCom} alt='Off' onClick={togglePassword} />}
                                    {/* </button> */}
                                </div>
                            </Form.Group>
                            <Form.Group className="form-group position-relative">
                                <Form.Label>Enter Confirm Password</Form.Label>
                                <TextInputGroup type={passwordType} onChange={handlePasswordChange1} value={passwordInput1} name="confirm_password" placeholder="Password" required />
                                <div className="input-group-btn passShowHideBtn position-absolute">
                                    {/* <button className="btn btn-outline-primary"> */}
                                    {passwordType === "password" ? <img className='w-100' src={eyeSvgrepoCom} alt='On' onClick={togglePassword} /> : <img className='w-100' alt='Off' src={eyeOffSvgrepoCom} onClick={togglePassword} />}
                                    {/* </button> */}
                                </div>

                            </Form.Group>
                            <div className="login-btn">
                                <Button type="submit" className="btn btn_primary" disabled={isSubmitting} aria-busy={isSubmitting}>
                                    {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                                    {strings.sign_up}
                                </Button>
                            </div>
                            <div className="already_cls">
                                <p>{strings.already_account} <Link to="#" onClick={openLogin}>{strings.sign_in}</Link></p>
                            </div>
                        </div>
                    </ValidationForm>
                </Modal.Body>
            </Modal>
        </>

    )
}
export default connect(mapStateToProps, mapDispatchToProps)(Register)
